<template>
    <div class="content mt20">
        <div class="account-content bgfff">
            <vipMenu></vipMenu>
        </div>
        <div class="bgfff mt20 clearfix">
            <div class="member-c">
                <div class="permission-comparison clearfix flex">
                    <div class="member-li1 member-li01 pt45">
                        <span class="fw7">权限对比</span>
                    </div>
                    <div class="member-li1" v-for="(item,index) in $parent.vipCollocation" :key="index" :class="item.className">
                        <div class="in">
                            <div class="member-level ac"><i :class="item.icon == '' ? '' : item.icon"></i> <span>{{item.name}}</span></div>
                            <div class="member-a mt5" v-if="position === index && position != 0"><router-link :to="{path:'/personalCenter/memberPurchase',query:{'level':item.level}}">续费</router-link></div>
                            <div class="member-a mt5" v-if="position < index"><a href="javascript:void(0);" @click="buyVip(item.level)">立即开通</a></div>
                        </div>
                    </div>
                </div>
                <div class="table-warp">
                    <table class="table table-qx" width="100%" border="0" cellpadding="0" cellspacing="0">
                        <colgroup>
                        </colgroup>
                        <tr v-for="(item,index) in infomation" :key="index">
                            <td v-for="(items,index1) in item" :key="index1" v-html="items"></td>
                        </tr>
                    </table>
                </div>
            </div>
        </div>
        <!-- 联系客服 -->
        <Dialog ref="wxModal" title="联系客服" type="normal" width=320 :modalFoot="false">
            <div slot="mdBox">
                <img src="/static/images/kefu.png" class="w100"/>
                <h3 class="ac">请扫描上方微信二维码联系客服申请开通机构版会员</h3>
            </div>
        </Dialog>
  	</div>
</template>
<script>
import vipMenu from './vipMenu.vue';
import Dialog from '../../components/dialog.vue';
export default {
    components:{vipMenu,Dialog},
    data() {
        return {
            infomation:[],
            position:'',//等级在数组的位置
            level:''
        }
    },
    mounted() {
        let that = this;
        that.$nextTick(()=> {
           that.getInfomation();
        })
    },
    created() {
		
    },
    methods: {
        getInfomation () {
            let that = this;
            that.$parent.loadModal(true,'获取数据中...');
            that.$api.post('personal/plusinfo',null,r => {
                that.$parent.showLoad = false;
                that.$parent.returnCode(r,function(){
                    that.infomation = r.data.list;
                    that.level = r.data.level;
                    for(let i in that.$parent.vipCollocation){
                        if(r.data.levels[i] === r.data.level){
                            that.position = parseInt(i);
                        }
                        that.$parent.vipCollocation[i].level = r.data.levels[i];
                    }
                })
            })
        },
        // 立即开通
        buyVip (level) {
            let that = this;
            if(level != 20){//非机构版
                that.$router.push({path:'/personalCenter/memberPurchase',query:{'level':level}})
            }else{
                that.$refs.wxModal.showMaskFun();
            }
        }
	}
}
</script>



// WEBPACK FOOTER //
// src/page/personalCenter/permissionComparison.vue